import React, { useState, useEffect, useRef } from 'react';
import {
  Col,
  Row,
  Container,
  Button,
  ListGroup,
  ListGroupItem,
  Breadcrumb,
  BreadcrumbItem,
  Form,
  Input,
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Badge,
  Collapse,
} from 'reactstrap';
import { connect } from 'react-redux';
import { getProducts, filterProducts, resetProducts } from '../actions/productsActions';
import Spinner from './Spinner';
import Slide from 'react-reveal';
import { addToCart } from '../actions/shoppingCart';
import ButtonSpinner from './ButtonSpinner';
import { Helmet } from 'react-helmet';
import Flip from 'react-reveal/Flip';
import queryString from 'query-string';
import Base from './Base';
import image from '../images/products.jpg';
import { useHistory, useLocation } from 'react-router-dom';

const ProductsPage = (props: any) => {
  const { products, auth, cart, guest } = props;
  const history = useHistory();
  const location = useLocation();

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [showId, setShowId] = useState('');
  const [sortDropDown, setSortDropDown] = useState(false);
  const [filter, setFilter] = useState('default');
  const [productSearch, setProductSearch] = useState('');
  const [searchQuery, setSearchQuery] = useState(location.search);
  const [collapseAustralian, setCollapseAustralian] = useState(false);
  const [collapseAustralianTropical, setCollapseAustralianTropical] = useState(false);
  const [collapseAustralianFruits, setCollapseAustralianFruits] = useState(false);
  const [collapseOrganic, setCollapseOrganic] = useState(false);
  const [collapseOrganicVegetables, setCollapseOrganicVegetables] = useState(false);
  const [collapseOrganicFruits, setCollapseOrganicFruits] = useState(false);
  const [collapseConventional, setCollapseConventional] = useState(false);
  const [collapseConventionalVegetables, setCollapseConventionalVegetables] = useState(false);
  const [collapseConventionalFruits, setCollapseConventionalFruits] = useState(false);
  const [collapseConventionalTropical, setCollapseConventionalTropical] = useState(false);
  const [collapsePuree, setCollapsePuree] = useState(false);
  const [collapsePureeFruit, setCollapsePureeFruit] = useState(false);

  const myRef = useRef(null);
  const prevSearchQueryRef = useRef(searchQuery);
  const prevLocationSearchRef = useRef(location.search);

  const updateWindowDimensions = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  useEffect(() => {
    updateWindowDimensions();
    window.addEventListener('resize', updateWindowDimensions);

    const parsed: any = queryString.parse(location.search) as any;

    let page = 1;
    let orderby = 'default';
    let query;
    let category;
    let subCategory;
    let initialFilter = 'default';

    if (parsed.category) {
      category = parsed.category;
    }
    if (parsed.subCategory) {
      subCategory = parsed.subCategory;
    }
    if (parsed.page) {
      page = parsed.page;
    }
    if (parsed.orderby) {
      orderby = parsed.orderby;
      initialFilter = parsed.orderby;
    }
    if (parsed.productSearch) {
      query = parsed.productSearch;
    }

    setFilter(initialFilter);

    if (products.products.length === 0 || products.reset) {
      props.getProducts(page, orderby, query, category, subCategory);
    }
    if (products.reset) {
      props.resetProducts();
    }

    if (parsed.category === 'australian') {
      setCollapseAustralian(true);
      if (parsed.subCategory === 'fruits') setCollapseAustralianFruits(true);
      if (parsed.subCategory === 'tropical') setCollapseAustralianTropical(true);
    }
    if (parsed.category === 'organic') {
      setCollapseOrganic(true);
      if (parsed.subCategory === 'fruits') setCollapseOrganicFruits(true);
      if (parsed.subCategory === 'vegetables') setCollapseOrganicVegetables(true);
    }
    if (parsed.category === 'conventional') {
      setCollapseConventional(true);
      if (parsed.subCategory === 'fruits') setCollapseConventionalFruits(true);
      if (parsed.subCategory === 'vegetables') setCollapseConventionalVegetables(true);
    }

    return () => {
      window.removeEventListener('resize', updateWindowDimensions);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Push URL when searchQuery state changes
  useEffect(() => {
    if (searchQuery !== prevSearchQueryRef.current) {
      prevSearchQueryRef.current = searchQuery;
      history.push(`/shop${searchQuery}`);
    }
  });

  // Fetch products when URL search changes
  useEffect(() => {
    if (location.search !== prevLocationSearchRef.current) {
      prevLocationSearchRef.current = location.search;
      const parsed = queryString.parse(location.search) as any;
      let page;
      let orderby;
      let query;
      let category;
      let subCategory;
      let newFilter = 'default';

      if (parsed.page) page = parsed.page;
      if (parsed.subCategory) subCategory = parsed.subCategory;
      if (parsed.orderby && parsed.orderby !== 'default') orderby = parsed.orderby;
      if (parsed.productSearch) query = parsed.productSearch;
      if (parsed.category) category = parsed.category;

      const stringified = queryString.stringify(parsed);
      if (stringified.length > 0) {
        setSearchQuery('?' + stringified);
      } else {
        setSearchQuery('');
      }

      if (parsed.orderby) newFilter = parsed.orderby;
      setFilter(newFilter);

      scrollToMyRef();
      props.getProducts(page, orderby, query, category, subCategory);
    }
  });

  const scrollToMyRef = () => {
    if (!products.productsLoading && myRef.current) {
      window.scrollTo(0, myRef.current.offsetTop);
    }
  };

  const handleSubCategory = (category, subCategory) => {
    const parsed = queryString.parse(location.search) as any;
    parsed.category = category;
    parsed.subCategory = subCategory;
    parsed.page = 1;
    if (parsed.productSearch) {
      parsed.productSearch = undefined;
    }
    const stringified = queryString.stringify(parsed);
    setSearchQuery('?' + stringified);
  };

  const handleCategory = (value) => {
    const parsed = queryString.parse(location.search) as any;
    parsed.page = 1;
    parsed.category = value;
    if (value === 'other' || value === 'drygoods' || value === 'puree') {
      parsed.productSearch = undefined;
      parsed.subCategory = undefined;
    }
    const stringified = queryString.stringify(parsed);
    setSearchQuery('?' + stringified);
  };

  const handleSubCategoryProducts = (category, subCategory, productName) => {
    const parsed = queryString.parse(location.search) as any;
    parsed.productSearch = productName;
    parsed.category = category;
    parsed.subCategory = subCategory;
    const stringified = queryString.stringify(parsed);
    setSearchQuery('?' + stringified);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const parsed = queryString.parse(location.search) as any;
    parsed.productSearch = productSearch;
    const stringified = queryString.stringify(parsed);
    if (stringified.length > 0) {
      setSearchQuery('?' + stringified);
      setProductSearch('');
    } else {
      setSearchQuery('');
      setProductSearch('');
    }
  };

  const handleSearch = (e) => {
    setProductSearch(e.target.value);
  };

  const dropdownToggle = () => {
    setSortDropDown((prev) => !prev);
  };

  const setSort = (value) => {
    const parsed = queryString.parse(location.search) as any;
    if (parsed.page) parsed.page = 1;
    if (parsed.orderby && value !== 'default') {
      parsed.orderby = value;
    } else if (value !== 'default') {
      parsed.orderby = value;
    } else {
      parsed.orderby = undefined;
    }
    const stringified = queryString.stringify(parsed);
    if (stringified.length > 0) {
      setFilter(value);
      setSearchQuery('?' + stringified);
    } else {
      setFilter(value);
      setSearchQuery('');
    }
  };

  const adjustCart = (product) => {
    if (cart.addToCartLoading.productId !== product._id) {
      if (auth.isAuthenticated) {
        props.addToCart(product, auth.user.id);
      } else {
        props.addToCart(product, guest.userid || undefined);
      }
    }
  };

  const handleHover = (product) => {
    setShowId(product._id);
  };

  const resetHover = () => {
    setShowId('');
  };

  const routeToSpecificPage = (product) => {
    history.push({
      pathname: `/shop/${product.name.replace(/[^A-Z0-9]+/gi, '-')}/${product._id}`,
      state: { product },
    });
  };

  const handleShopClick = () => {
    setSearchQuery('');
  };

  const resetSearchQuery = () => {
    const parsed = queryString.parse(location.search) as any;
    parsed.productSearch = undefined;
    parsed.page = 1;
    const stringified = queryString.stringify(parsed);
    if (stringified.length !== 0) {
      setSearchQuery('?' + stringified);
    } else {
      setSearchQuery('');
    }
  };

  const resetSort = () => {
    const parsed = queryString.parse(location.search) as any;
    parsed.page = 1;
    if (parsed.orderby) parsed.orderby = undefined;
    const stringified = queryString.stringify(parsed);
    if (stringified.length !== 0) {
      setFilter('default');
      setSearchQuery('?' + stringified);
    } else {
      setFilter('default');
      setSearchQuery('');
    }
  };

  const handlePageChange = (i) => {
    const parsed = queryString.parse(location.search) as any;
    parsed.page = i + 1;
    const stringified = queryString.stringify(parsed);
    setSearchQuery('?' + stringified);
  };

  const previousPage = () => {
    const parsed = queryString.parse(location.search) as any;
    parsed.page = parseInt(parsed.page) - 1;
    const stringified = queryString.stringify(parsed);
    setSearchQuery('?' + stringified);
  };

  const nextPage = () => {
    const parsed = queryString.parse(location.search) as any;
    if (parsed.page) {
      parsed.page = parseInt(parsed.page) + 1;
    } else {
      parsed.page = 2;
    }
    const stringified = queryString.stringify(parsed);
    setSearchQuery('?' + stringified);
  };

  const resetCategory = () => {
    const parsed = queryString.parse(location.search) as any;
    parsed.category = undefined;
    parsed.subCategory = undefined;
    parsed.page = undefined;
    const stringified = queryString.stringify(parsed);
    if (stringified.length > 0) {
      setSearchQuery('?' + stringified);
    } else {
      setSearchQuery('');
    }
  };

  const resetSubCategory = () => {
    const parsed = queryString.parse(location.search) as any;
    parsed.subCategory = undefined;
    const stringified = queryString.stringify(parsed);
    if (stringified.length > 0) {
      setSearchQuery('?' + stringified);
    } else {
      setSearchQuery('');
    }
  };

  const parsed = queryString.parse(location.search) as any;
  let end;
  let totalItemNumbers = products.totalPageNumbers;
  let currentPage;
  if (parsed.page) {
    if (parsed.page > [...Array(Math.ceil(products.totalPageNumbers / 12))].length) {
      currentPage = [...Array(Math.ceil(products.totalPageNumbers / 12))].length;
    } else if (parsed.page <= 1) {
      currentPage = 1;
    } else {
      currentPage = parsed.page;
    }
  } else {
    currentPage = 1;
  }

  if (12 < totalItemNumbers) {
    end = 12 * currentPage;
    if (end > totalItemNumbers) {
      end = totalItemNumbers;
    }
  } else {
    end = totalItemNumbers;
  }

  return (
    <React.Fragment>
      <div>
        <Helmet>
          <title>Shop - Frozberries VIC - Affordable, Healthy, Delicios</title>
          <meta
            name="description"
            content="Shop Frozen Fruit, Vegetables and Purees brought to you by Frozberries Victoria. Deliciously hand picked and flash frozen after carefully hand picked to preserve all the nutritions."
          />
        </Helmet>
      </div>
      <Base title={'Products'} image={image} overlay />

      {products.productsLoading ? (
        <div style={{ height: '40vh' }}>
          <Container className="  h-100 ">
            <Row className="  h-100">
              <Col className=" my-auto">
                <div className=" text-center text-light">
                  <Spinner />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      ) : (
        <div className="products-page " ref={myRef}>
          <Row className="mt-3">
            <Col>
              <div className="border-bottom">
                <Breadcrumb className="">
                  <BreadcrumbItem style={{ cursor: 'pointer' }} onClick={() => history.push('/')}>
                    Home
                  </BreadcrumbItem>
                  <BreadcrumbItem style={{ cursor: 'pointer' }} onClick={handleShopClick}>
                    Shop
                  </BreadcrumbItem>
                  {parsed.category && (
                    <BreadcrumbItem style={{ cursor: 'pointer' }} active>
                      Category: {parsed.category.toUpperCase()}
                    </BreadcrumbItem>
                  )}
                  {parsed.subCategory && (
                    <BreadcrumbItem style={{ cursor: 'pointer' }} active>
                      Sub-category: {parsed.subCategory.toUpperCase()}
                    </BreadcrumbItem>
                  )}
                  {parsed.productSearch && (
                    <BreadcrumbItem style={{ cursor: 'pointer' }} active>
                      Product Search: {parsed.productSearch.toUpperCase()}
                    </BreadcrumbItem>
                  )}
                  {parsed.page ? (
                    parsed.page > [...Array(Math.ceil(products.totalPageNumbers / 12))].length ? (
                      <BreadcrumbItem style={{ cursor: 'pointer' }} active>
                        Page {[...Array(Math.ceil(products.totalPageNumbers / 12))].length}
                      </BreadcrumbItem>
                    ) : parsed.page <= 1 ? (
                      <BreadcrumbItem style={{ cursor: 'pointer' }} active>
                        Page 1
                      </BreadcrumbItem>
                    ) : (
                      <BreadcrumbItem style={{ cursor: 'pointer' }} active>
                        Page {parsed.page}
                      </BreadcrumbItem>
                    )
                  ) : (
                    <BreadcrumbItem style={{ cursor: 'pointer' }} active>
                      Page 1
                    </BreadcrumbItem>
                  )}
                </Breadcrumb>
              </div>
            </Col>
          </Row>
          <Row className="px-3 py-3 mt-3 ">
            <Col lg="3" className={width < 992 ? 'order-2' : ''}>
              <h5 className="font-weight-bold " style={{ fontSize: '1.4rem' }}>
                PRODUCT SEARCH
              </h5>
              <Form className="my-3 pr-3" onSubmit={handleSubmit}>
                <Input
                  name="productSearch"
                  value={productSearch}
                  placeholder="Search Products"
                  onChange={handleSearch}
                />
              </Form>

              <h5 className="font-weight-bold mt-5" style={{ fontSize: '1.4rem' }}>
                SHOP
              </h5>
              <ListGroup className="mt-3">
                <ListGroupItem
                  style={{ padding: 0, lineHeight: 2, fontSize: '1.2rem', border: 0 }}
                  className="border-top border-bottom"
                >
                  <span
                    style={{
                      cursor: 'pointer',
                      color:
                        parsed.category === 'australian' ? 'rgb(235,24,79)' : 'rgb(109,117,125)',
                    }}
                    onClick={() => handleCategory('australian')}
                  >
                    AUSTRALIAN
                  </span>
                  <span className="float-right">
                    {collapseAustralian ? (
                      <i
                        style={{ cursor: 'pointer' }}
                        onClick={() => setCollapseAustralian((p) => !p)}
                        className="fas fa-minus-circle"
                      ></i>
                    ) : (
                      <i
                        style={{ cursor: 'pointer' }}
                        onClick={() => setCollapseAustralian((p) => !p)}
                        className="fas fa-plus-circle"
                      ></i>
                    )}
                  </span>

                  <Collapse isOpen={collapseAustralian}>
                    <div style={{ fontSize: '1rem', border: 0, paddingLeft: 10 }}>
                      <span
                        onClick={() => handleSubCategory('australian', 'fruits')}
                        style={{
                          lineHeight: 1.5,
                          cursor: 'pointer',
                          color:
                            parsed.category === 'australian' && parsed.subCategory === 'fruits'
                              ? 'rgb(235,24,79)'
                              : 'rgb(109,117,125)',
                        }}
                      >
                        Fruits{' '}
                      </span>
                      <span className="float-right">
                        {collapseAustralianFruits ? (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapseAustralianFruits((p) => !p)}
                            className="fas fa-minus-circle"
                          ></i>
                        ) : (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapseAustralianFruits((p) => !p)}
                            className="fas fa-plus-circle"
                          ></i>
                        )}
                      </span>

                      <Collapse isOpen={collapseAustralianFruits} style={{ paddingLeft: 10 }}>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'australian' &&
                              parsed.productSearch === 'blackberries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('australian', 'fruits', 'blackberries')
                          }
                        >
                          Blackberries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'australian' &&
                              parsed.productSearch === 'blackcurrants'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('australian', 'fruits', 'blackcurrants')
                          }
                        >
                          Blackcurrants
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'australian' &&
                              parsed.productSearch === 'blueberries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('australian', 'fruits', 'blueberries')
                          }
                        >
                          Blueberries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'australian' &&
                              parsed.productSearch === 'blackcurrants'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('australian', 'fruits', 'boysenberries')
                          }
                        >
                          Boysenberries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'australian' &&
                              parsed.productSearch === 'mixed berries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('australian', 'fruits', 'mixed berries')
                          }
                        >
                          Mixed Berries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'australian' &&
                              parsed.productSearch === 'raspberries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('australian', 'fruits', 'raspberries')
                          }
                        >
                          Raspberries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'australian' &&
                              parsed.productSearch === 'strawberries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('australian', 'fruits', 'strawberries')
                          }
                        >
                          Strawberries
                        </div>
                      </Collapse>
                    </div>

                    <div style={{ border: 0, fontSize: '1rem', paddingLeft: 10 }}>
                      <span
                        onClick={() => handleSubCategory('australian', 'tropical')}
                        style={{
                          lineHeight: 1.5,
                          cursor: 'pointer',
                          color:
                            parsed.category === 'australian' && parsed.subCategory === 'tropical'
                              ? 'rgb(235,24,79)'
                              : 'rgb(109,117,125)',
                        }}
                      >
                        Tropical{' '}
                      </span>
                      <span className="float-right">
                        {collapseAustralianTropical ? (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapseAustralianTropical((p) => !p)}
                            className="fas fa-minus-circle"
                          ></i>
                        ) : (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapseAustralianTropical((p) => !p)}
                            className="fas fa-plus-circle"
                          ></i>
                        )}
                      </span>

                      <Collapse isOpen={collapseAustralianTropical} style={{ paddingLeft: 10 }}>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'australian' &&
                              parsed.productSearch === 'mango cheeks'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('australian', 'tropical', 'mango cheeks')
                          }
                        >
                          Mango Cheeks
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'australian' &&
                              parsed.productSearch === 'mango diced'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('australian', 'tropical', 'mango diced')
                          }
                        >
                          Mango Diced
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'australian' &&
                              parsed.productSearch === 'mango puree'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('australian', 'tropical', 'mango puree')
                          }
                        >
                          Mango Puree
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'australian' &&
                              parsed.productSearch === 'pineapple chunks'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('australian', 'tropical', 'pineapple chunks')
                          }
                        >
                          Pineapple Chunks
                        </div>
                      </Collapse>
                    </div>
                  </Collapse>
                </ListGroupItem>

                <ListGroupItem
                  style={{ padding: 0, lineHeight: 2, fontSize: '1.2rem', border: 0 }}
                  className=" border-bottom"
                >
                  <span
                    style={{
                      cursor: 'pointer',
                      color: parsed.category === 'organic' ? 'rgb(235,24,79)' : 'rgb(109,117,125)',
                    }}
                    onClick={() => handleCategory('organic')}
                  >
                    ELGIN ORGANIC
                  </span>
                  <span className="float-right">
                    {collapseOrganic ? (
                      <i
                        style={{ cursor: 'pointer' }}
                        onClick={() => setCollapseOrganic((p) => !p)}
                        className="fas fa-minus-circle"
                      ></i>
                    ) : (
                      <i
                        style={{ cursor: 'pointer' }}
                        onClick={() => setCollapseOrganic((p) => !p)}
                        className="fas fa-plus-circle"
                      ></i>
                    )}
                  </span>

                  <Collapse isOpen={collapseOrganic}>
                    <div style={{ fontSize: '1rem', border: 0, paddingLeft: 10 }}>
                      <span
                        onClick={() => handleSubCategory('organic', 'fruits')}
                        style={{
                          lineHeight: 1.5,
                          cursor: 'pointer',
                          color:
                            parsed.category === 'organic' && parsed.subCategory === 'fruits'
                              ? 'rgb(235,24,79)'
                              : 'rgb(109,117,125)',
                        }}
                      >
                        Fruits{' '}
                      </span>
                      <span className="float-right">
                        {collapseOrganicFruits ? (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapseOrganicFruits((p) => !p)}
                            className="fas fa-minus-circle"
                          ></i>
                        ) : (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapseOrganicFruits((p) => !p)}
                            className="fas fa-plus-circle"
                          ></i>
                        )}
                      </span>

                      <Collapse isOpen={collapseOrganicFruits} style={{ paddingLeft: 10 }}>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'banana slices'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'fruits', 'banana slices')
                          }
                        >
                          Banana Slices
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'blackberries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'fruits', 'blackberries')
                          }
                        >
                          Blackberries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'blueberries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'fruits', 'blueberries')
                          }
                        >
                          Blueberries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'wild blueberries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'fruits', 'wild blueberries')
                          }
                        >
                          Wild Blueberries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'mango chunks'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'fruits', 'mango chunks')
                          }
                        >
                          Mango Chunks
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'mixed berries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'fruits', 'mixed berries')
                          }
                        >
                          Mixed berries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'pineapple pieces'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'fruits', 'pineapple pieces')
                          }
                        >
                          Pineapple Pieces
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'raspberries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'fruits', 'raspberries')
                          }
                        >
                          Raspberries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'strawberries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'fruits', 'strawberries')
                          }
                        >
                          Strawberries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'sour cherries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'fruits', 'sour cherries')
                          }
                        >
                          Sour Cherries - Pitted
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'sweet cherries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'fruits', 'sweet cherries')
                          }
                        >
                          Sweet Cherries - Pitted
                        </div>
                      </Collapse>
                    </div>

                    <div style={{ border: 0, fontSize: '1rem', paddingLeft: 10 }}>
                      <span
                        onClick={() => handleSubCategory('organic', 'vegetables')}
                        style={{
                          lineHeight: 1.5,
                          cursor: 'pointer',
                          color:
                            parsed.category === 'organic' && parsed.subCategory === 'vegetables'
                              ? 'rgb(235,24,79)'
                              : 'rgb(109,117,125)',
                        }}
                      >
                        Vegetables{' '}
                      </span>
                      <span className="float-right">
                        {collapseOrganicVegetables ? (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapseOrganicVegetables((p) => !p)}
                            className="fas fa-minus-circle"
                          ></i>
                        ) : (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapseOrganicVegetables((p) => !p)}
                            className="fas fa-plus-circle"
                          ></i>
                        )}
                      </span>

                      <Collapse isOpen={collapseOrganicVegetables} style={{ paddingLeft: 10 }}>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'beans green'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'vegetables', 'beans green')
                          }
                        >
                          Beans Green
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'broccoli florets'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'vegetables', 'broccoli florets')
                          }
                        >
                          Broccoli Florets
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'cauliflower florets'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts(
                              'organic',
                              'vegetables',
                              'cauliflower florets'
                            )
                          }
                        >
                          Cauliflower Florets
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'corn kernels'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'vegetables', 'corn kernels')
                          }
                        >
                          Corn Kernels
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'chopped kale'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'vegetables', 'chopped kale')
                          }
                        >
                          Chopped Kale
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'chopped spinach'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'vegetables', 'chopped spinach')
                          }
                        >
                          Chopped Spinach
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' && parsed.productSearch === 'peas'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() => handleSubCategoryProducts('organic', 'vegetables', 'peas')}
                        >
                          Peas
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'spring harvest mix'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'vegetables', 'spring harvest mix')
                          }
                        >
                          Spring Harvest Mix
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'organic' &&
                              parsed.productSearch === 'carrots diced'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('organic', 'vegetables', 'carrots diced')
                          }
                        >
                          Carrots Diced
                        </div>
                      </Collapse>
                    </div>
                  </Collapse>
                </ListGroupItem>

                <ListGroupItem
                  style={{ padding: 0, lineHeight: 2, fontSize: '1.2rem', border: 0 }}
                  className=" border-bottom"
                >
                  <span
                    style={{
                      cursor: 'pointer',
                      color:
                        parsed.category === 'conventional' ? 'rgb(235,24,79)' : 'rgb(109,117,125)',
                    }}
                    onClick={() => handleCategory('conventional')}
                  >
                    CONVENTIONAL
                  </span>
                  <span className="float-right">
                    {collapseConventional ? (
                      <i
                        style={{ cursor: 'pointer' }}
                        onClick={() => setCollapseConventional((p) => !p)}
                        className="fas fa-minus-circle"
                      ></i>
                    ) : (
                      <i
                        style={{ cursor: 'pointer' }}
                        onClick={() => setCollapseConventional((p) => !p)}
                        className="fas fa-plus-circle"
                      ></i>
                    )}
                  </span>

                  <Collapse isOpen={collapseConventional}>
                    <div style={{ fontSize: '1rem', border: 0, paddingLeft: 10 }}>
                      <span
                        onClick={() => handleSubCategory('conventional', 'fruits')}
                        style={{
                          lineHeight: 1.5,
                          cursor: 'pointer',
                          color:
                            parsed.category === 'conventional' && parsed.subCategory === 'fruits'
                              ? 'rgb(235,24,79)'
                              : 'rgb(109,117,125)',
                        }}
                      >
                        Fruits{' '}
                      </span>
                      <span className="float-right">
                        {collapseConventionalFruits ? (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapseConventionalFruits((p) => !p)}
                            className="fas fa-minus-circle"
                          ></i>
                        ) : (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapseConventionalFruits((p) => !p)}
                            className="fas fa-plus-circle"
                          ></i>
                        )}
                      </span>

                      <Collapse isOpen={collapseConventionalFruits} style={{ paddingLeft: 10 }}>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'blackberries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('conventional', 'fruits', 'blackberries')
                          }
                        >
                          Blackberries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'blueberries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('conventional', 'fruits', 'blueberries')
                          }
                        >
                          Blueberries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'wild blueberries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('conventional', 'fruits', 'wild blueberries')
                          }
                        >
                          Wild Blueberries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'sweet cherries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('conventional', 'fruits', 'sweet cherries')
                          }
                        >
                          Cherries - Dark Sweet
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'sour cherries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('conventional', 'fruits', 'sour cherries')
                          }
                        >
                          Cherries - Red Sour
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'cranberries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('conventional', 'fruits', 'cranberries')
                          }
                        >
                          Cranberries
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'mixed berries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('conventional', 'fruits', 'mixed berries')
                          }
                        >
                          Mixed Berries (7 Berries)
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'raspberries'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('conventional', 'fruits', 'raspberries')
                          }
                        >
                          Raspberries (Whole)
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'redcurrants'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('conventional', 'fruits', 'redcurrants')
                          }
                        >
                          Redcurrants
                        </div>
                      </Collapse>
                    </div>

                    <div style={{ border: 0, fontSize: '1rem', paddingLeft: 10 }}>
                      <span
                        onClick={() => handleSubCategory('conventional', 'vegetables')}
                        style={{
                          lineHeight: 1.5,
                          cursor: 'pointer',
                          color:
                            parsed.category === 'conventional' &&
                            parsed.subCategory === 'vegetables'
                              ? 'rgb(235,24,79)'
                              : 'rgb(109,117,125)',
                        }}
                      >
                        Vegetables{' '}
                      </span>
                      <span className="float-right">
                        {collapseConventionalVegetables ? (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapseConventionalVegetables((p) => !p)}
                            className="fas fa-minus-circle"
                          ></i>
                        ) : (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapseConventionalVegetables((p) => !p)}
                            className="fas fa-plus-circle"
                          ></i>
                        )}
                      </span>

                      <Collapse isOpen={collapseConventionalVegetables} style={{ paddingLeft: 10 }}>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'rhubarb'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('conventional', 'vegetables', 'rhubarb')
                          }
                        >
                          Rhubarb
                        </div>
                      </Collapse>
                    </div>

                    <div style={{ border: 0, fontSize: '1rem', paddingLeft: 10 }}>
                      <span
                        onClick={() => handleSubCategory('conventional', 'tropical')}
                        style={{
                          lineHeight: 1.5,
                          cursor: 'pointer',
                          color:
                            parsed.category === 'conventional' && parsed.subCategory === 'tropical'
                              ? 'rgb(235,24,79)'
                              : 'rgb(109,117,125)',
                        }}
                      >
                        Tropical{' '}
                      </span>
                      <span className="float-right">
                        {collapseConventionalTropical ? (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapseConventionalTropical((p) => !p)}
                            className="fas fa-minus-circle"
                          ></i>
                        ) : (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapseConventionalTropical((p) => !p)}
                            className="fas fa-plus-circle"
                          ></i>
                        )}
                      </span>

                      <Collapse isOpen={collapseConventionalTropical} style={{ paddingLeft: 10 }}>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'avocado quarters'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts(
                              'conventional',
                              'tropical',
                              'avocado quarters'
                            )
                          }
                        >
                          Avocado Quarters
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'banana slices'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('conventional', 'tropical', 'banana slices')
                          }
                        >
                          Banana Slices
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'banana chunks'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('conventional', 'tropical', 'banana chunks')
                          }
                        >
                          Banana Chunks
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'dragonfruit'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('conventional', 'tropical', 'dragonfruit')
                          }
                        >
                          Dragonfruit
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'mango chunks'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('conventional', 'tropical', 'mango chunks')
                          }
                        >
                          Mango Chunks
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'conventional' &&
                              parsed.productSearch === 'pineapple chunks'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts(
                              'conventional',
                              'tropical',
                              'pineapple chunks'
                            )
                          }
                        >
                          Pineapple Chunks
                        </div>
                      </Collapse>
                    </div>
                  </Collapse>
                </ListGroupItem>

                <ListGroupItem
                  style={{ padding: 0, lineHeight: 2, fontSize: '1.2rem', border: 0 }}
                  className=" border-bottom"
                >
                  <span
                    style={{
                      cursor: 'pointer',
                      color: parsed.category === 'puree' ? 'rgb(235,24,79)' : 'rgb(109,117,125)',
                    }}
                    onClick={() => handleCategory('puree')}
                  >
                    PUREES &amp; JUICES
                  </span>
                  <span className="float-right">
                    {collapsePuree ? (
                      <i
                        style={{ cursor: 'pointer' }}
                        onClick={() => setCollapsePuree((p) => !p)}
                        className="fas fa-minus-circle"
                      ></i>
                    ) : (
                      <i
                        style={{ cursor: 'pointer' }}
                        onClick={() => setCollapsePuree((p) => !p)}
                        className="fas fa-plus-circle"
                      ></i>
                    )}
                  </span>

                  <Collapse isOpen={collapsePuree}>
                    <div style={{ fontSize: '1rem', border: 0, paddingLeft: 10 }}>
                      <span
                        onClick={() => handleSubCategory('puree', 'fruit')}
                        style={{
                          lineHeight: 1.5,
                          cursor: 'pointer',
                          color:
                            parsed.category === 'puree' && parsed.subCategory === 'fruit'
                              ? 'rgb(235,24,79)'
                              : 'rgb(109,117,125)',
                        }}
                      >
                        Fruit Purees / Pulps{' '}
                      </span>
                      <span className="float-right">
                        {collapsePureeFruit ? (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapsePureeFruit((p) => !p)}
                            className="fas fa-minus-circle"
                          ></i>
                        ) : (
                          <i
                            style={{ cursor: 'pointer' }}
                            onClick={() => setCollapsePureeFruit((p) => !p)}
                            className="fas fa-plus-circle"
                          ></i>
                        )}
                      </span>

                      <Collapse isOpen={collapsePureeFruit} style={{ paddingLeft: 10 }}>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'puree' &&
                              parsed.productSearch === 'passionfruit cubes seed in'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts(
                              'puree',
                              'fruit',
                              'passionfruit cubes seed in'
                            )
                          }
                        >
                          Passionfruit Cubes Seed In
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'puree' &&
                              parsed.productSearch === 'passionfruit pulp seed in'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts('puree', 'fruit', 'passionfruit pulp seed in')
                          }
                        >
                          Passionfruit Pulp Seed In
                        </div>
                        <div
                          style={{
                            fontSize: '0.9rem',
                            cursor: 'pointer',
                            color:
                              parsed.category === 'puree' &&
                              parsed.productSearch === 'passionfruit pulp seed out'
                                ? 'rgb(235,24,79)'
                                : 'rgb(109,117,125)',
                          }}
                          onClick={() =>
                            handleSubCategoryProducts(
                              'puree',
                              'fruit',
                              'passionfruit pulp seed out'
                            )
                          }
                        >
                          Passionfruit Pulp Seed Out
                        </div>
                      </Collapse>
                    </div>
                  </Collapse>
                </ListGroupItem>
              </ListGroup>
            </Col>
            <Col>
              <Row>
                <Col>
                  <div className="my-3">
                    {parsed.category && (
                      <h5
                        className="d-inline pr-3"
                        style={{ cursor: 'pointer' }}
                        onClick={resetCategory}
                      >
                        {' '}
                        <Badge color="danger">
                          Category:{' '}
                          {parsed.category === 'puree'
                            ? 'PUREES & JUICES'
                            : parsed.category.toUpperCase()}
                          <span className="ml-2" style={{ fontSize: '1.2rem' }}>
                            &times;
                          </span>
                        </Badge>
                      </h5>
                    )}

                    {parsed.subCategory && (
                      <h5
                        className="d-inline pr-3"
                        style={{ cursor: 'pointer' }}
                        onClick={resetSubCategory}
                      >
                        {' '}
                        <Badge color="danger">
                          Sub-category: {parsed.subCategory.toUpperCase()}
                          <span className="ml-2" style={{ fontSize: '1.2rem' }}>
                            &times;
                          </span>
                        </Badge>
                      </h5>
                    )}
                    {parsed.productSearch && (
                      <h5
                        className="d-inline pr-3"
                        style={{ cursor: 'pointer' }}
                        onClick={resetSearchQuery}
                      >
                        {' '}
                        <Badge color="danger">
                          {parsed.productSearch.toUpperCase()}
                          <span className="ml-2" style={{ fontSize: '1.2rem' }}>
                            &times;
                          </span>
                        </Badge>
                      </h5>
                    )}

                    {parsed.orderby &&
                      (parsed.orderby === 'pricelow' ? (
                        <h5
                          className="d-inline px-3"
                          style={{ cursor: 'pointer' }}
                          onClick={resetSort}
                        >
                          {' '}
                          <Badge color="danger">
                            PRICE LOW TO HIGH
                            <span className="ml-2" style={{ fontSize: '1.2rem' }}>
                              &times;
                            </span>
                          </Badge>
                        </h5>
                      ) : (
                        parsed.orderby === 'pricehigh' && (
                          <h5
                            className="d-inline px-3"
                            style={{ cursor: 'pointer' }}
                            onClick={resetSort}
                          >
                            {' '}
                            <Badge color="danger">
                              PRICE HIGH TO LOW
                              <span className="ml-2" style={{ fontSize: '1.2rem' }}>
                                &times;
                              </span>
                            </Badge>
                          </h5>
                        )
                      ))}
                  </div>
                  {products.products.length !== 0 && (
                    <h1 className="float-left text-muted" style={{ fontSize: '0.9rem' }}>
                      Showing{' '}
                      {(queryString.parse(location.search) as any).page
                        ? (queryString.parse(location.search) as any).page <= 1
                          ? 1
                          : (queryString.parse(location.search) as any).page >
                              [...Array(Math.ceil(products.totalPageNumbers / 12))].length
                            ? ([...Array(Math.ceil(products.totalPageNumbers / 12))].length - 1) *
                                13 -
                              1
                            : (parseInt((queryString.parse(location.search) as any).page) - 1) *
                                12 +
                              1
                        : 1}{' '}
                      – {end} of {products.totalPageNumbers} results
                    </h1>
                  )}

                  {products.products.length !== 0 && (
                    <div className="float-right">
                      <h1 style={{ fontSize: '0.9rem' }} className="d-inline text-muted">
                        Sort by :
                      </h1>
                      <Dropdown
                        size="sm"
                        className="btn-sm  ml-auto d-inline"
                        isOpen={sortDropDown}
                        toggle={dropdownToggle}
                      >
                        <DropdownToggle caret className=" bg-light text-dark">
                          {filter === '' || filter === 'default'
                            ? 'Best selling'
                            : filter === 'pricelow'
                              ? 'Price(low to high)'
                              : filter === 'pricehigh' && 'Price(high to low)'}
                        </DropdownToggle>
                        <DropdownMenu right>
                          <DropdownItem onClick={() => setSort('default')}>
                            Best selling
                          </DropdownItem>
                          <DropdownItem onClick={() => setSort('pricelow')}>
                            Price(low to high)
                          </DropdownItem>
                          <DropdownItem onClick={() => setSort('pricehigh')}>
                            Price(high to low)
                          </DropdownItem>
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  )}
                </Col>
              </Row>
              <Row className="mt-3">
                {products.products.length !== 0 ? (
                  products.products.map((product) => (
                    <Col
                      md="4"
                      sm="6"
                      xs="6"
                      key={product._id}
                      className=" text-center  item my-2"
                      onMouseEnter={() => handleHover(product)}
                      onMouseLeave={() => resetHover()}
                    >
                      <div
                        style={{ cursor: 'pointer' }}
                        onClick={() => routeToSpecificPage(product)}
                      >
                        <div className="img-outer ">
                          <div className="position-relative">
                            {!product.inStock && (
                              <div className="corner-ribbon top-right sticky blue">
                                Out of stock
                              </div>
                            )}
                            <img
                              className="img-fluid product-image"
                              src={product.image}
                              alt={product.name}
                            />
                          </div>
                        </div>
                        <div>
                          <h5
                            className={
                              width > 576
                                ? `text-left pt-3 product-desc`
                                : `text-center pt-3 product-desc`
                            }
                            style={{ fontSize: '16px', fontWeight: 400 }}
                          >
                            {product.name}
                          </h5>
                          <h5
                            className="font-weight-bold d-inline"
                            style={{ fontSize: '17px', color: 'rgb(236,23,79)' }}
                          >
                            <span className={width > 576 ? 'float-left' : 'text-center'}>
                              ${product.price.toFixed(2)}
                            </span>
                            {width < 576 && <br />}
                            {cart.cart.map(
                              (each) =>
                                each.product._id === product._id && (
                                  <Slide
                                    key={each.product._id}
                                    left
                                    warning={
                                      cart.cart.length === 0
                                        ? false
                                        : cart.cart.map((each) => each.product._id === product._id)
                                          ? true
                                          : false
                                    }
                                  >
                                    <span
                                      style={{ fontSize: '14px' }}
                                      className={
                                        width > 576
                                          ? 'float-right font-weight-bold text-muted'
                                          : 'font-weight-bold text-muted'
                                      }
                                    >
                                      +{each.quantity} Added
                                    </span>
                                  </Slide>
                                )
                            )}
                          </h5>
                        </div>
                      </div>

                      {width > 576 ? (
                        <Flip top when={showId === product._id}>
                          <div
                            className="text-center border-top "
                            style={{ minWidth: '100px', marginTop: 30 }}
                          >
                            <Button
                              size="sm"
                              disabled={!product.inStock}
                              style={{
                                backgroundColor: 'rgb(236,23,79)',
                                borderRadius: 30,
                                minWidth: '103.44px',
                              }}
                              className="  mx-2 my-2 border-0 "
                              onClick={() => adjustCart(product)}
                            >
                              {cart.addToCartLoading.productId === product._id ? (
                                <ButtonSpinner />
                              ) : (
                                '    Add to Cart'
                              )}
                            </Button>
                            <Button
                              size="sm"
                              onClick={() => routeToSpecificPage(product)}
                              style={{ borderRadius: 30 }}
                              color="dark"
                              outline
                            >
                              View Details
                            </Button>
                          </div>
                        </Flip>
                      ) : (
                        <div
                          className="text-center border-top "
                          style={{ minWidth: '100px', marginTop: 10 }}
                        >
                          <Button
                            size="sm"
                            disabled={!product.inStock}
                            style={{
                              backgroundColor: 'rgb(236,23,79)',
                              borderRadius: 30,
                              minWidth: '103.44px',
                            }}
                            className="  mx-2 my-2 border-0 "
                            onClick={() => adjustCart(product)}
                          >
                            {cart.addToCartLoading.productId === product._id ? (
                              <ButtonSpinner />
                            ) : (
                              '    Add to Cart'
                            )}
                          </Button>
                          <Button
                            size="sm"
                            onClick={() => routeToSpecificPage(product)}
                            style={{ borderRadius: 30 }}
                            color="dark"
                            outline
                          >
                            View Details
                          </Button>
                        </div>
                      )}
                    </Col>
                  ))
                ) : (
                  <Col>
                    <h5>No results found. </h5>
                  </Col>
                )}
              </Row>

              {[...Array(Math.ceil(products.totalPageNumbers / 12))].length > 1 &&
                products.products.length !== 0 && (
                  <Row className="text-center mt-5">
                    <Col className="text-center ">
                      <nav aria-label="Page navigation example">
                        <ul className="pagination justify-content-center">
                          <li
                            className={
                              !(queryString.parse(location.search) as any).page ||
                              (queryString.parse(location.search) as any).page <= 1
                                ? 'disabled page-item '
                                : `page-item`
                            }
                          >
                            <span
                              className="page-link"
                              style={{ color: 'rgb(235,24,79)', cursor: 'pointer' }}
                              onClick={previousPage}
                            >
                              Previous
                            </span>
                          </li>
                          {[...Array(Math.ceil(products.totalPageNumbers / 12))].map((page, i) => (
                            <li
                              key={i}
                              className={
                                !(queryString.parse(location.search) as any).page && i + 1 === 1
                                  ? 'active page-item'
                                  : (queryString.parse(location.search) as any).page <= 1 &&
                                      i + 1 === 1
                                    ? 'active page-item'
                                    : (queryString.parse(location.search) as any).page >= 2 &&
                                        i + 1 ===
                                          parseInt((queryString.parse(location.search) as any).page)
                                      ? 'active page-item'
                                      : (queryString.parse(location.search) as any).page >
                                            [...Array(Math.ceil(products.totalPageNumbers / 12))]
                                              .length &&
                                          i + 1 ===
                                            [...Array(Math.ceil(products.totalPageNumbers / 12))]
                                              .length
                                        ? 'active page-item'
                                        : 'page-item'
                              }
                            >
                              <span
                                className="page-link"
                                style={{ color: 'rgb(235,24,79)', cursor: 'pointer' }}
                                onClick={() => handlePageChange(i)}
                              >
                                {i + 1}
                              </span>
                            </li>
                          ))}

                          <li
                            className={
                              (queryString.parse(location.search) as any).page >=
                              [...Array(Math.ceil(products.totalPageNumbers / 12))].length
                                ? 'disabled page-item'
                                : 'page-item'
                            }
                          >
                            <span
                              style={{ color: 'rgb(235,24,79)', cursor: 'pointer' }}
                              className="page-link"
                              onClick={nextPage}
                            >
                              Next
                            </span>
                          </li>
                        </ul>
                      </nav>
                    </Col>
                  </Row>
                )}
            </Col>
          </Row>
        </div>
      )}
    </React.Fragment>
  );
};

const mapStateToProps = (state: any) => ({
  products: state.products,
  auth: state.form,
  cart: state.cart,
  guest: state.guest,
});

export default connect(mapStateToProps, {
  getProducts,
  filterProducts,
  addToCart,
  resetProducts,
})(ProductsPage);
